export default __webpack_public_path__ + "static/media/product.5bb05a71.jpg";